import { useTranslation } from 'react-i18next';
import { DiscordCtaSource, useOnboardingBrand } from './onboardingBrand';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { DiscordIcon } from '@/Domain/components/icons/Discord.icon';
import { cn } from '@/Domain/utils/cn';

/**
 * The in-brand "Add to your Discord server" CTA. Opens the one-click Discord sheet
 * overlay (via the onboarding-brand context) and nudges that personality + KB can be
 * edited after connecting. Shared by the first page and the Deployment step.
 */
export const DiscordAddToServerCta = ({
  source,
  className,
}: {
  source: DiscordCtaSource;
  className?: string;
}) => {
  const { t } = useTranslation('getting_started');
  const { openDiscordSheet } = useOnboardingBrand();

  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <Button
        type="button"
        onClick={() => openDiscordSheet(source)}
        data-testid="gs-discord-add-to-server"
        className="w-full border-0 bg-[var(--qc-discord-blurple)] text-white hover:bg-[var(--qc-discord-blurple-hover)]"
      >
        <DiscordIcon className="size-5" style={{ fill: 'currentColor' }} />
        {t('automatic_flow.discord.add_to_server')}
      </Button>
      <p
        className="px-2 text-center text-xs text-[var(--qc-discord-muted)]"
        data-testid="gs-discord-kb-hint"
      >
        {t('automatic_flow.discord.personality_kb_hint')}
      </p>
    </div>
  );
};
